import {
  PdfFontFamily,
  PdfOrientation,
  PdfPageFormat,
  PdfTemplateProperties,
} from '../../ui/pages/PdfTemplateEditor/PdfComponent';
import { CompanyEntity } from '../common/entity';

export enum PdfTemplateEntityType {
  order = 'order',
}

export enum PdfTemplateEntitySubtype {
  inbound = 'inbound',
  outbound = 'outbound',
  move = 'move',
  disposal = 'disposal',
}

export class PdfTemplate extends CompanyEntity {
  name!: string;
  entityType!: PdfTemplateEntityType;
  entitySubtype!: PdfTemplateEntitySubtype;
  properties: PdfTemplateProperties = {
    document: {
      font: { family: PdfFontFamily.helvetica, size: 9, color: '#111111' },
      pageFormat: PdfPageFormat.A4,
      orientation: PdfOrientation.portrait,
    },
    components: [],
  };

  constructor(obj: any) {
    if (!obj.companyId) return;
    super(obj.companyId);
    Object.assign(this, obj);
    // If comes from backend
    if (typeof obj.properties === 'string') {
      obj.properties = JSON.parse(obj.properties);
    }
  }
}
